import { render } from "./RightMenu.vue?vue&type=template&id=6a556cc4&scoped=true"
import script from "./RightMenu.vue?vue&type=script&lang=js"
export * from "./RightMenu.vue?vue&type=script&lang=js"

import "./RightMenu.vue?vue&type=style&index=0&id=6a556cc4&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a556cc4"]])

export default __exports__